import { forwardRef } from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../utils/cn';

const spinnerVariants = cva(
	// Base styles
	"animate-spin rounded-full border-2 border-current border-t-transparent",
	{
		variants: {
			size: {
				sm: "h-4 w-4",
				md: "h-6 w-6",
				lg: "h-8 w-8",
				xl: "h-12 w-12"
			},
			variant: {
				// Brand indigo by default - the app's loading moments should carry
				// its identity, not look like an unstyled bootstrap artifact.
				default: "text-brand-600",
				light: "text-white",
				muted: "text-muted-foreground",
				primary: "text-brand-600",
			}
		},
		defaultVariants: {
			size: "md",
			variant: "default"
		}
	}
);

const Spinner = forwardRef(({
	className,
	size,
	variant,
	...props
}, ref) => {
	return (
		<div
			ref={ref}
			className={cn(spinnerVariants({ size, variant, className }))}
			{...props}
		/>
	);
});

Spinner.displayName = "Spinner";

export { Spinner, spinnerVariants }; 